'use client';

import Link from 'src/components/primitives/Link/Link';
import SvgBgDiv from '../Utils/SvgBgDiv';
import { PreLaunchMarketWarning } from './PreLaunchMarketAlertUtils';
import { PRE_MARKET_ACKNOWLEDGED_WARNING_KEY } from './PreLaunchMarketConstants';
import useModal from 'src/components/Modals/hooks/useModal';
import BaseModal from 'src/components/primitives/BaseModal/BaseModal';
import Button from 'src/components/primitives/Button/Button';
import { useSyncLocalStorage } from 'src/hooks/useSyncLocalStorage';

export interface PreLaunchMarketWarningModalProps {
	type: PreLaunchMarketWarning;
}

export default function PreLaunchMarketWarningModal({
	type,
}: PreLaunchMarketWarningModalProps) {
	const { hide } = useModal();

	if (type === 'acknowledge_terms') {
		return <PreLaunchMarketWarningAlert onContinue={hide} />;
	}

	return null;
}

const PreLaunchMarketWarningAlert = ({
	onContinue,
}: {
	onContinue: () => void;
}) => {
	const [, setAcknowledged] = useSyncLocalStorage(
		PRE_MARKET_ACKNOWLEDGED_WARNING_KEY,
		false
	);

	return (
		<BaseModal.Container onClose={() => {}}>
			<BaseModal.Title>Pre-Launch Market</BaseModal.Title>

			<BaseModal.Body className="flex flex-col">
				<SvgBgDiv
					svgPath="/assets/images/prelaunch/warning-alert-bg.svg"
					className="flex h-[194px] flex-col items-center justify-center text-text-default"
				>
					<div className="flex flex-col items-center space-x-1">
						<span className="typo-b4">Introducing</span>
						<span className="typo-b3">Pre-Launch Markets</span>
					</div>
				</SvgBgDiv>

				<span>
					Pre-Launch Markets are for Traders interested in speculating on the
					listing price of a token that has not been launched.
				</span>
				<span>Learn how Prelaunch markets work here:</span>
				<Link
					href="https://docs.drift.trade/trading/prelaunch-markets"
					openInNewTab
				>
					About Pre-Launch Markets
				</Link>
			</BaseModal.Body>

			<BaseModal.Footer>
				<Button
					size="md"
					variant="secondary"
					className="w-full"
					onClick={() => {
						setAcknowledged(true);
						onContinue();
					}}
				>
					I understand
				</Button>
			</BaseModal.Footer>
		</BaseModal.Container>
	);
};
